import React, { HTMLProps, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { GOALS } from '../../../../config/goals';
import { GoalIndicationContext } from '../../../../contexts/investment-robot/GoalIndicationContext';
import { GoalQuestionBase } from '../goal-question/GoalQuestionBase';
import { PathIcon } from '../../../../config/iconSelector';
import { RobotEnvironmentContext } from '../../../../contexts/general/RobotEnvironmentContext';
import { getGoalSpecificPages } from '../../../../utils/functions';
import { useTranslation } from 'react-i18next';

export const GoalIndication: React.FC<{} & HTMLProps<HTMLDivElement>> = () => {
    const goalIndication = useContext(GoalIndicationContext);
    const robotEnvironmentContext = useContext(RobotEnvironmentContext);
    const history = useHistory();
    const { t } = useTranslation('investment');

    return (

        <>
            <GoalQuestionBase header={{ title: t("goal-question-title"), description: t("goal-question-description")}}>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-6 gap-x-6">
                    { GOALS.map((goal, i) => {
                        return (
                            <div
                                key={goal.id}
                                data-goal-id={goal.id}
                                className="goal-indication"
                                onClick={() => {
                                    goalIndication.actions.setParameters({ selectedGoal: goal.id });
                                    history.push(getGoalSpecificPages(goal.pages, robotEnvironmentContext.contactDetailsOption)[0].routes.current);
                                }}
                            >
                                <div className="flex flex-row items-center bg-white shadow-lg rounded-lg px-4 py-6 cursor-pointer">
                                    {PathIcon(goal.id, 'mr-4 w-12 h-12 text-bnd-green')}
                                    <div className="flex flex-shrink flex-1 flex-col">
                                        <span className="font-semibold text-bnd-black-1 dark:text-bnd-white-1">
                                            {goal.label}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </GoalQuestionBase>
            <GoalIndicationDisclaimer />
        </>
    );
};

const GoalIndicationDisclaimer: React.FC<{} & HTMLProps<HTMLDivElement>> = () => {
    const { t } = useTranslation('investment');
    
    return ( 
        <div className="flex flex-col items-center md:mx-8 mx-4 mb-4">
            <div className="flex flex-col items-between justify-center max-w-7xl w-full">
                <div className="text-base lg:text-lg font-semibold">
                    {t("goal-indication-screen-no-advice-disclaimer-title")}
                </div>
                <div className="text-sm text-gray-700">
                    <span>
                        {t("goal-indication-screen-no-advice-disclaimer-text")}
                    </span>
                </div>

            </div>
        </div>
    );
}